import React from "react";
import { Skeleton } from "@common/skeleton";

function Icon({ className }: { className: string }) {
  return <Skeleton className={className} />;
}

export { Icon };
